import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';

interface SettlementCreatedToasterProps {
  onClose: () => void;
  onViewSettlement: () => void;
  settlementName: string;
}

export default function SettlementCreatedToaster({
  onClose,
  onViewSettlement,
  settlementName,
}: SettlementCreatedToasterProps) {
  return (
    <Box
      sx={{
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
        {t('approvals.driver_pay.settlements.settlement_created', {
          name: settlementName,
        })}
      </Typography>

      <SmallButton
        color="brandV2Green"
        onClick={(event) => {
          event.stopPropagation();
          onViewSettlement();
          onClose();
        }}
        size="small"
        variant="contained"
      >
        {t('approvals.driver_pay.settlements.view_settlement')}
      </SmallButton>
    </Box>
  );
}
